import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/vehicle_gate_times/statistics',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/vehicle_gate_times/export',
    method: 'get',
    params,
  })
}
